import styled, { css } from 'styled-components';
import { Spacer } from '@ontruck/orc';

export const StyledHeaderContainer = styled.div`
  display: flex;
  width: 1400px;
  align-items: flex-end;
  + div {
    > div {
      margin: 0 auto;
    }
  }
`;

const activeStyles = ({ isActive }) => {
  return (
    isActive &&
    css`
      background-color: var(--grey700);
      color: #fff;
    `
  );
};

const orderStyles = ({ order, isActive }) => {
  if (!order) {
    return '';
  }

  const borderColor = isActive ? '#fff' : 'var(--grey700)';

  if (order === 'asc') {
    return css`
      &:after {
        border-width: 0 3px 6px 3px;
        border-bottom-color: ${borderColor};
      }
    `;
  }

  if (order === 'desc') {
    return css`
      &:after {
        border-width: 6px 3px 0 3px;
        border-top-color: ${borderColor};
      }
    `;
  }

  return '';
};

export const StyledHeaderCell = styled(Spacer).attrs(() => ({
  mRight: 'S',
}))`
  display: flex;
  flex: 0 0 ${({ cellWidth }) => cellWidth}px;
  color: var(--grey700);
  padding-bottom: 3px;
  cursor: pointer;
  align-items: center;
  border-radius: 2px 2px 0 0;
  position: relative;
  line-height: 1.3;
  padding-top: 0.4rem;
  padding-left: 0.2rem;

  &:after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    border-color: transparent;
  }

  ${activeStyles}
  ${orderStyles}
`;
